const EMPTY_TEMPLATE_DELTA = {
  ops: [{ insert: "\n" }],
};

const HTML_TAG_REGEX = /<\/?[a-z][\s\S]*>/i;

export const createEmptyTemplateDelta = () => ({
  ops: [{ insert: "\n" }],
});

export const parseStoredTemplateBody = (body) => {
  if (!body) {
    return null;
  }

  try {
    const parsedBody = JSON.parse(body);
    if (Array.isArray(parsedBody?.ops)) {
      return parsedBody;
    }
  } catch {
    return null;
  }

  return null;
};

export const getTemplateEditorValue = (body) =>
  parseStoredTemplateBody(body) ?? body ?? EMPTY_TEMPLATE_DELTA;

export const serializeTemplateDelta = (delta) =>
  JSON.stringify(delta ?? EMPTY_TEMPLATE_DELTA);

export const isTemplateBodyEmpty = (body) => {
  const parsedDelta = parseStoredTemplateBody(body);

  if (parsedDelta) {
    const plainText = parsedDelta.ops
      .map((op) => (typeof op.insert === "string" ? op.insert : ""))
      .join("")
      .replace(/\n/g, "")
      .trim();

    return !plainText;
  }

  if (typeof body !== "string") {
    return true;
  }

  if (HTML_TAG_REGEX.test(body) && typeof DOMParser !== "undefined") {
    const parser = new DOMParser();
    const document = parser.parseFromString(body, "text/html");
    return !document.body.textContent.trim();
  }

  return !body.trim();
};
